<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "",
	data() {
		return {
			asideList: [
				{
					title: "用户列表",
					icon: "",
					router: "/user/userlist",
					permissions: 801,
				},
				{
					title: "新增用户",
					icon: "",
					router: "/user/adduser",
					permissions: 802,
				},
				{
					title: "配置管理",
					icon: "",
					router: "/user/config",
					permissions: 804,
				},
				{
					title: "专栏作者认证",
					icon: "",
					router: "/user/examinelist",
					permissions: 805,
				},
			],
		};
	},

	mounted() {
		const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			this.asideList = this.asideList.filter((item) =>
				permissionArray.includes(item.permissions)
			);
		}
	},
};
</script>

<style scoped></style>
